import { render, staticRenderFns } from "./PurchasingPurchaseOrdersPreferences.vue?vue&type=template&id=e2659986&"
import script from "./PurchasingPurchaseOrdersPreferences.vue?vue&type=script&lang=js&"
export * from "./PurchasingPurchaseOrdersPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCheckbox,VTooltip})
